<div class="divider" [ngStyle]="getStyles()"></div>